<template>
  <div class="downloads_container">
    <div class="downloads_content">
      <div class="rank_search">
        <input type="text" v-model="search_val" placeholder="输入文件名称" @keyup="searchFn" />
        <div class="search_btn" @click="searchFn"></div>
      </div>
      <!-- <div class="downloads_tit">研究报告</div> -->
      <div class="downloads_tabs">
        <div :class="[
          'downloads_tab',
          item.category == cur_category ? 'act' : '',
        ]" v-for="(item, ind) in tabs_list" :key="ind" @click="changeTab(item.category)">
          {{ item.name }}
        </div>
      </div>
      <div class="downloads_tabs downloads_tabs_dsf" v-if="cur_category == '第三方报告'">
        <div :class="[
          'downloads_tab',
          item.category == cur_dsf_category ? 'act' : '',
        ]" v-for="(item, ind) in dsf_tabs_list" :key="ind" @click="changeDsfTab(item.category)">
          {{ item.name }}
        </div>
      </div>
      <div class="downloads_list">
        <el-table empty-text="暂无数据,敬请期待。" :data="tableData" style="width: 100%" :scrollbar-always-on="true">
          <!-- <el-table-column prop="report_num" label="编号" /> -->
          <el-table-column prop="report_name" label="报告名称" class="report_name" />
          <el-table-column prop="published" label="发布日期" width="250" />
          <el-table-column label="操作" width="150">
            <template #default="scope">
              <span v-if="scope.row.has_preview == 1" class="down_btn" @click="preview(scope.row)">预览</span>

              <template v-if="scope.row.has_permission == 1">
                <span class="down_btn" @click="downLoad(scope.row)">下载</span>
              </template>
              <template v-else>
                <span class="down_btn" @click="downLoad(null)">下载</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div class="list_pagination" v-show="totalPage > 1">
          <el-pagination v-model:currentPage="currentPage" :background="true" layout="prev, pager, next, jumper"
            :page-count="totalPage" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog v-model="dialogVisible" :title="reportTitle" fullscreen="true">
      <iframe style="height: 100%; width:100%;" :src="pdfSrc" frameborder="0" ref="iframeRef"
        class="full-size-iframe"></iframe>
    </el-dialog>

    <!-- <div class="interfereDownload" v-show="dialogVisible"></div> -->
  </div>
</template>

<script>
import { ref } from "vue";
import { useRoute } from 'vue-router';
import { ElTable, ElTableColumn, ElPagination, ElMessage, ElDialog } from "element-plus";
import { getDownloadsList, previewReport } from "@/api";
export default {
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
    ElDialog,
  },
  setup() {
    const route = useRoute();
    const search_val = ref("");
    const cur_category = ref("");
    const cur_dsf_category = ref("");
    const dialogVisible = ref(false);
    const pdfSrc = ref("");
    const iframeRef = ref(null);
    const reportTitle = ref("");
    const tabs_list = [
      {
        name: "全部",
        category: '',
      },
      {
        name: "OTA报告",
        category: "OTA报告",
      },
      {
        name: "专题报告",
        category: "专题报告",
      },
      {
        name: "用户调研报告",
        category: "用户调研报告",
      },
      {
        name: "车云业务介绍",
        category: "车云业务介绍",
      },
      {
        name: "第三方报告",
        category: "第三方报告",
      },
    ];

    const dsf_tabs_list = [
      {
        name: "全部",
        category: '',
      },
      {
        name: "产业链报告",
        category: "产业链报告",
      },
      {
        name: "智能座舱报告",
        category: "智能座舱报告",
      },
      {
        name: "智能驾驶报告",
        category: "智能驾驶报告",
      },
      {
        name: "车企报告",
        category: "车企报告",
      },
      {
        name: "行业报告",
        category: "行业报告",
      },
    ];

    if (route.query.cur_category) {
      cur_category.value = route.query.cur_category
    }
    const tableData = ref([]);
    const totalPage = ref(0);
    const currentPage = ref(1);
    const handleCurrentChange = (val) => {
      getDownloadsListFn({ page: val });
    };
    const getDownloadsListFn = (obj = {}) => {
      let { category, page } = obj;
      getDownloadsList({
        category: category || cur_category.value,
        dsf_category: cur_dsf_category.value,
        page: page || currentPage.value,
        size: 8,
        keyword: search_val.value,
      }).then((res) => {
        if (res && res.code && res.code == 200) {
          tableData.value = res.data.list;
          totalPage.value = res.data.total_page;
        }
      });
    };
    const searchFn = () => {
      currentPage.value = 1;
      getDownloadsListFn();
    };
    const changeTab = (category) => {
      cur_category.value = category;
      currentPage.value = 1;
      getDownloadsListFn();
    };
    const changeDsfTab = (category) => {
      cur_dsf_category.value = category;
      currentPage.value = 1;
      getDownloadsListFn();
    };

    async function forceDownload(url, fileName) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');

        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName || 'download'; // 设置文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href); // 清理
      } catch (error) {
        console.error('Download failed:', error);
      }
    }

    const downLoad = (report) => {
      if (report && report.download_link) {
        forceDownload(report.download_link, report.file_name)
      } else {
        ElMessage.error("暂无下载权限!");
      }


      //   const loginToken = getCookie('loginToken');
      //   if (report && report.report_num) {
      //     downReport({
      //       report_num: report.report_num
      //     },
      //       {
      //         responseType: 'arraybuffer',
      //         headers: {
      //           appvars: { "loginToken": loginToken },
      //           ContentType: 'application/json'
      //         },
      //       }
      //     ).then(response => {
      //       if (response && response.code && response.code === 500) {
      //         ElMessage.error(response.message || "暂无下载权限!");
      //         return;
      //       }

      //       let arrayBuffer = response; // Assuming response is ArrayBuffer

      //       let blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });

      //       let url = URL.createObjectURL(blob);

      //       let a = document.createElement('a');
      //       a.style.display = 'none';
      //       a.href = url;
      //       a.download = decodeURIComponent(report.file_name);
      //       document.body.appendChild(a);
      //       a.click();
      //       window.URL.revokeObjectURL(url);
      //       document.body.removeChild(a);
      //     })
      //   } else {
      //     ElMessage.error("暂无下载权限!");
      //   }
    }

    const preview = (report) => {

      if (report && report.report_num) {
        previewReport({
          report_num: report.report_num
        }).then(response => {
          if (response && response.code && response.code === 500) {
            ElMessage.error(response.message || "暂无下载权限!");
            return;
          }
          reportTitle.value = "文件预览 " + report.report_name;
          if (iframeRef.value) {
            iframeRef.value.style.height = '100%'
          }
          dialogVisible.value = true
          pdfSrc.value = response.data.path

        })
      } else {
        ElMessage.error("暂无下载权限!");
      }
    }

    return {
      dialogVisible,
      cur_category,
      cur_dsf_category,
      tabs_list,
      dsf_tabs_list,
      tableData,
      totalPage,
      currentPage,
      handleCurrentChange,
      changeTab,
      downLoad,
      preview,
      pdfSrc,
      iframeRef,
      reportTitle,
      changeDsfTab,
      search_val,
      searchFn
    };
  },
};
</script>

<style lang="less" scoped>
:deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
  background-color: #1FBCBF;
}

:deep(.el-pagination .btn-next .el-icon) {
  margin: 0 auto;
}

:deep(.el-pagination .btn-prev .el-icon) {
  margin: 0 auto;
}

:deep(.el-table__row) {
  height: 50px;
}

:deep(.el-table_1_column_1 .cell) {
  color: #474747;
}

:deep(.el-dialog__body) {
  height: 95%;
  margin-top: -25px;
}

:deep(.el-dialog__close) {
  --font-size: 36px;
}

:deep(.el-dialog__header) {
  z-index: 100001;
}

:deep(.el-dialog__title) {
  font-size: 28px;
}

.downloads_content {
  width: 1100px;
  height: calc(100vh - 128px);
  padding: 28px 69px 35px 63px;
  background: #ffffff;
  border-radius: 13px;
  overflow-y: auto;

  .downloads_tit {
    height: 31px;
    font-size: 20px;
    font-weight: bold;
    color: #474747;
    line-height: 31px;
    position: relative;
    padding-left: 10px;
  }

  .downloads_tabs {
    // margin-top: 30px;
    display: flex;
    align-items: center;
    height: 48px;

    .downloads_tab {
      cursor: pointer;
      margin-right: 25px;
      padding: 0 25px;
      height: 100%;
      font-size: 16px;
      font-weight: bold;
      color: #474747;
      line-height: 48px;
      text-align: center;

      &.act {
        border-bottom: solid 4px #1FBCBF;
        border-radius: 2px;
      }
    }
  }

  .downloads_tabs_dsf {
    .downloads_tab {
      font-size: 14px;
      color: #6d6565;
    }
  }

  .downloads_list {
    margin-top: 21px;
    height: calc(100% - 52px);

    :deep(.el-table) {
      overflow-y: auto;
    }

    .list_pagination {
      display: flex;
      justify-content: center;
      margin-top: 20px;

    }
  }
}

.down_btn {
  cursor: pointer;
  color: #1435eb;
  margin-right: 5px;
}

:deep(.el-table::before) {
  height: 0;
}

.interfereDownload {
  width: 100%;
  height: 60px;
  background-color: white;
  position: fixed;
  z-index: 10000;
  top: 58px;
  left: 0;
}

.toOtaList {
  margin: 20px 0;
  text-align: center;
}

.rank_search {
  width: 500px;
  height: 38px;
  border-radius: 2px;
  background-position: 162px center;
  display: flex;
  align-items: center;
  border: 1px solid #d7d7d7;

  input {
    width: 100%;
    height: 100%;
    appearance: none;
    outline: none;
    border: none;
    background: transparent;
    padding: 0 10px 0 20px;
    font-size: 14px;

    &::placeholder {
      color: #bebebe;
    }
  }

  &:has(input:focus) {
    border: 1px solid #1FBCBF;
  }

  .search_btn {
    width: 50px;
    height: 100%;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png) no-repeat center center;
    background-size: 17px 17px;
    cursor: pointer;
  }
}
</style>